<template>
  <v-container grid-list-xs>
    <v-row>
      <v-col cols="12">
        <v-form :submit="submitSearch">
          <v-card color="grey-lighten-2">
            <v-card-title>
              Filtro de pesquisa
              <DialogCreateUpdateNews
                                      :user="user"
                                      v-if="canCreate"
                                      v-model="editModel"
                                      :floatRight="true"
                                      @created="createdNews" />
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                                v-model="filters.searchText"
                                label="Nome"
                                clearable
                                density="compact"
                                hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" align-self="start">
                  <v-row align="start" density="compact">
                    <v-col cols="12" md="2">
                      <v-label>Data</v-label>
                    </v-col>
                    <v-col cols="12" md="5">
                      <v-text-field type="date" label="De" density="compact" v-model="filters.date_from">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="5">
                      <v-text-field type="date" label="Até" density="compact" v-model="filters.date_to">
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" sm="4" md="3">
                  <v-select
                            :items="[50, 100, 200, 500]"
                            v-model="filters.itemsPerPage"
                            label="Resultados por página"
                            density="compact"
                            hide-details></v-select>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-btn color="warning" @click="clearFilters()"><v-icon class="mr-2">mdi-broom</v-icon>Limpar
                  pesquisa</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit">
                  <v-icon class="mr-2">mdi-magnify</v-icon>
                  Pesquisar
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Notícias
            <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table
                        :headers="headers"
                        :items="lstObjects"
                        :search="searchFilter"
                        :items-per-page="filters.itemsPerPage"
                        return-object
                        class="elevation-1"
                        hide-default-footer>
            <template v-slot:bottom>
              <div class="text-center pt-2">
                <v-pagination
                              :disabled="requestingApi"
                              v-model="page"
                              :length="maxPage"></v-pagination>
              </div>
            </template>
            <template v-slot:item.status="{ value }">
              <span>{{ $NEWS_STATUS_DIC[value]?.label || value }}</span>
            </template>
            <template v-slot:item.schedule="{ item }">
              <span>{{
                $moment(item.schedule || item.updated_at).format(
                  "DD/MM/YYYY"
                )
              }}</span>
            </template>
            <template v-slot:item.receivers_read_percent="{ item }">
              <span>{{ item.receivers_read_count && item.receivers_count ? (item.receivers_read_count * 100
                /
                item.receivers_count).toFixed(0) : 0 }}</span>
            </template>
            <template v-slot:item.actions="{ item, index }">
              <v-menu v-if="item.status == 0 || item.status == 1">
                <template v-slot:activator="{ props }">
                  <v-btn icon variant="text" v-bind="props"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                </template>
                <v-list>
                  <v-list-item
                               v-if="canEdit"
                               @click="editNews(item, index)">
                    <v-list-item-title>
                      <v-icon color="primary" class="mr-2">mdi-pencil</v-icon>
                      Editar Notícia
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                               v-if="canDelete"
                               @click="deleteNews(item, index)">
                    <v-list-item-title>
                      <v-icon color="red" class="mr-2">mdi-delete</v-icon>
                      Excluir Notícia</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-btn
                     v-else
                     color="primary"
                     icon
                     variant="text"
                     @click="openNews(item)"><v-icon>mdi-eye</v-icon></v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import DialogCreateUpdateNews from "@/components/DialogCreateUpdateNews.vue";
import api from '@/services'
export default {
  components: {
    DialogCreateUpdateNews,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      requestingApi: false,
      tabNews: "list",
      headers: [
        { title: "Nome", align: "start", key: "name", sortable: false },
        { title: "Status", key: "status", sortable: false },
        { title: "Data", key: "schedule", sortable: false },
        { title: "Destinatários", key: "receivers_count", sortable: false },
        { title: "Visualizações", key: "receivers_read_count", sortable: false },
        { title: "% Alcance", key: "receivers_read_percent", sortable: false },
        { title: "", key: "actions", align: "end", sortable: false },
      ],
      lstObjects: [],
      editModel: {},
      filters: {
        itemsPerPage: 1,
        date_from: null,
        date_to: null
      },
      searchFilter: null,
      page: 1,
      maxPage: 1,
    };
  },
  created() {
    var vm = this;
    vm.loadParameters();
  },
  mounted() { },
  activated() { },
  methods: {
    loadParameters() {
      var vm = this;
      let _itemsPerPage = localStorage["_news_itemsPerPage"];
      vm.filters.itemsPerPage = parseInt(_itemsPerPage || 10);
    },
    openNews(news) {
      var vm = this;
      vm.editModel = news;
    },
    clearFilters() {
      var vm = this;
      vm.filters.searchText = null;
      vm.searchFilter = null;
    },
    createdNews(news) {
      var vm = this;
      vm.lstObjects.unshift(news);
    },
    editNews(news, index) {
      var vm = this;
      vm.editModel = news;
    },
    deleteNews(news, index) {
      var vm = this;
      let _confirm = confirm(`Deseja realmente escluir a notícia ${news.name}`);
      if (_confirm) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.news
            .delete(news.id)
            .then((result) => {
              vm.lstObjects.splice(index, 1);
              vm.$notify({
                type: "success",
                text: "Notícia excluida",
              });
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    submitSearch(page) {
      var vm = this;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        vm.page = page || 1;
        return new Promise((resolve, reject) => {
          api.news
            .list(Object.keys(vm.filters)?.filter(f => vm.filters[f] != null).map(f => `${f}=${vm.filters[f]}`), page || 1)
            .then((result) => {
              vm.lstObjects = result || [];
              vm.maxPage = Math.ceil(
                (result?.total || 1) / (result?.per_page || 10)
              );
              vm.$notify({
                type: "success",
                text: "Pesquisa concluída",
              });
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
  },
  computed: {
    canCreate() {
      return this.user.access_level >= this.$USER_ACCESS_LEVELS_DIC.CHIEF.value;
    },
    canEdit() {
      return this.user.access_level >= this.$USER_ACCESS_LEVELS_DIC.CHIEF.value;
    },
    canDelete() {
      return (
        this.user.access_level >= this.$USER_ACCESS_LEVELS_DIC.GROUP_ADMIN.value
      );
    },
  },
  watch: {
    "filters.itemsPerPage"(newVal) {
      localStorage["_news_itemsPerPage"] = newVal;
    },
    page(newVal) {
      var vm = this;
      if (!isNaN(newVal)) {
        vm.submitSearch(newVal);
      }
    },
  },
};
</script>